import {Component, Vue} from 'vue-property-decorator';
import $ from 'jquery';
import log from 'js-logger';
import { supportJitsi } from '@/components/calls/services/browser/browser-utils';
import {_SCREEN_SHARE_STORE, SCREEN_SHARE_EVENTS} from '@/components/screen-share/values/screen-share.values';
import {CallsService} from '@/components/calls/services/calls.service';
import {APP_SOCKET_EVENTS, APP_SOCKET_MESSAGES_TYPE} from '@/core/values/app.values';
import KEYS from '@/values/keys';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import { Capacitor } from '@capacitor/core';

const { browser } = JitsiMeetJS.util;

declare const window: any;

@Component({})
export class EdJitsiMixin extends Vue {

    /**
     * Constantes
     */
    public PREFIX_CALL_MEETING: string = 'call-';
    public PREFIX_SCREENSHARE_MEETING: string = 'screenshare-';
    public TOHAINA_ERROR_CONN: string = 'errors.errorConnCallServer';
    public MODERATOR_ROLE: string = 'moderator';
    public LOCAL: string = 'local';
    public LB_UNDEFINED: string = 'undefined';
    public CONFERENCE_CONNECTION;
    public isConnecting = false;

    get isLocalSharingScreen(){
        return this.$store.state.ScreenShareStore.localIsOnScreenShare;
    }
    get isRemoteSharingScreen(){
        return this.$store.state.ScreenShareStore.remoteIsOnScreenShare;
    }
    get screenShareUrl() : string {
        return this.$store.state.AuthStore.screenShareUrl;
    }
    get isConnectingToMeeting () {
        return this.isConnecting;
    }
    //-- Utility Store functions
    _getConnection(){
        return this.$store.state.ScreenShareStore.conference.connection;
    }
    _getRoom(){
        return this.$store.state.ScreenShareStore.conference.room;
    }
    _getLocalUsername(){
        return this.$store.state.ScreenShareStore.conference.localUsername;
    }
    _updateConference(conference:any){
        this.$store.commit(_SCREEN_SHARE_STORE.MUTATIONS.SET_CONFERENCE, conference);
    }
    _updateParticipant(participant:any){
        //this.$store.commit(_SCREEN_SHARE_STORE.MUTATIONS.UPDATE_PARTICIPANTS, participant);
    }
    _removeParticipant(participant:any){
        //this.$store.commit(_SCREEN_SHARE_STORE.MUTATIONS.REMOVE_PARTICIPANT, participant);
    }
    _participantChanged(participantId:string){
        //this.$edEventBus.$emit(_SCREEN_SHARE_STORE.PARTICIPANT_CHANGED,participantId);
    }
    _findParticipant(participantId:string){
        //return this.$store.state.CallsStore.participants.find(p=> p.id === participantId);
        return null;
    }
    _cleanCallStarted(){
        this.$store.commit(_SCREEN_SHARE_STORE.MUTATIONS.END_SCREEN_SHARE);
    }
    _updateLocalIsOnScreenShare(isSharingScreen:any){
        this.$store.commit(_SCREEN_SHARE_STORE.MUTATIONS.LOCAL_IS_ON_SCREEN_SHARE, isSharingScreen);
    }
    _updateRemoteIsOnScreenShare(isSharingScreen:any){
        this.$store.commit(_SCREEN_SHARE_STORE.MUTATIONS.REMOTE_IS_ON_SCREEN_SHARE, isSharingScreen);
    }
    _tracks(participantId:string=this.LOCAL, type:string='all'){
        let p = this._findParticipant(participantId);
        let devs = [];
        if(p){
            if (type === 'video' && p.videoTrack) {
                devs.push(p.videoTrack);
            } else if (type === 'audio' && p.audioTrack) {
                devs.push(p.audioTrack);
            } else if (type === 'all') {
                if(p.videoTrack){ devs.push(p.videoTrack); }
                if(p.audioTrack){ devs.push(p.audioTrack); }
            }
        }
        return devs;
    }

    /**
     * Validate the navigator for calls
     */
    _isSupportCalls(){
        return supportJitsi();
    }

    _navigatorInfo(){
        return browser.getName() + ' - ' + browser.getVersion();
    }
    
    isElectron() { 
       return (window.electronVersions !== undefined);
    }

    /**
     * Connect to JitsiMeetJS
     */
    public _connect(conf) {
        this.isConnecting = true;
        // logger library
        // @ts-ignore
        log.useDefaults();
        conf.domain = conf.domain || this.screenShareUrl;   
        const electronProtocol = (this.isElectron() || Capacitor.isNativePlatform()) ? 'https:' : '';  
        return new Promise((resolve, reject) => {
            const options = {
                hosts: {
                    domain: `${conf.domain}`,
                    muc: `conference.${conf.domain}`
                },
                serviceUrl: `${electronProtocol}//${conf.domain}/http-bind`
            };

            JitsiMeetJS.setLogLevel(JitsiMeetJS.logLevels.INFO);
            JitsiMeetJS.init({ disableAudioLevels: true });
            JitsiMeetJS.mediaDevices.addEventListener(JitsiMeetJS.events.mediaDevices.PERMISSION_PROMPT_IS_SHOWN, browser => {});
            let connection = new JitsiMeetJS.JitsiConnection(null, null, options);
            connection.addEventListener(JitsiMeetJS.events.connection.CONNECTION_ESTABLISHED, () =>  this._onConnectionSuccess(connection, conf,resolve));
            connection.addEventListener(JitsiMeetJS.events.connection.CONNECTION_FAILED, ()=> this._onConnectionFailed(reject));
            connection.addEventListener(JitsiMeetJS.events.connection.CONNECTION_DISCONNECTED, this._disconnect);
            connection.connect();
            this._updateConference({ connection: connection, localUsername: conf.username,
                classId: conf.classId, meetingId: conf.meetingId});
           // this._updateParticipant({id:this.LOCAL, username: conf.username, userid: conf.userid, teacher: conf.teacher})
        });
    }

    /**
     * That function is called when connection is established successfully
     */
    async _onConnectionSuccess(connection, conf, resolve) {
        const conferenceOptions = { openBridgeChannel: 'websocket' };
        const sessionId = conf.meetingId;
        let meet = `${(this.PREFIX_SCREENSHARE_MEETING)}${sessionId}`
        let room = await connection.initJitsiConference(meet, conferenceOptions);

        this._updateConference({room: room})
        room.on(JitsiMeetJS.events.conference.CONFERENCE_JOINED, () => this._onConferenceJoined(resolve));
        room.on(JitsiMeetJS.events.conference.USER_JOINED, (id, user) => this._onRemoteJoin(id, user));
        room.on(JitsiMeetJS.events.conference.USER_LEFT, (id, user) => this._onUserLeft(id, user));
        room.on(JitsiMeetJS.events.conference.USER_ROLE_CHANGED, (id, role) => {
            if(this._isModerator(role)) {
                let tid = this._isLocalId(id) ? this.LOCAL : id;
                this._updateParticipant({id:tid, role:this.MODERATOR_ROLE})
            }
        });
        room.on(JitsiMeetJS.events.conference.DISPLAY_NAME_CHANGED, (id, displayName) => {
            let tid = this._isLocalId(id) ? this.LOCAL : id;
            this._updateParticipant({id:tid, username:displayName})
        });
        room.on(JitsiMeetJS.events.conference.TRACK_ADDED,  (track) => setTimeout(() => { this._onRemoteTrack(track) }, 450));
        room.on(JitsiMeetJS.events.conference.TRACK_REMOVED,  async (track) => {
            this._trackRemoved(track)
            track.detach(document.getElementById('screenShareContainer'));
            this._updateRemoteIsOnScreenShare(false);

            if( track.type === 'video' ) {
                await this._unload();
            }
        });
        room.on( JitsiMeetJS.events.conference.PARTICIPANT_CONN_STATUS_CHANGED, (id, status)  => {});

        room.on( JitsiMeetJS.events.conference.CONNECTION_INTERRUPTED, ()=> {
            this.showUserErrorMessage(String( this.$i18n.t('meetings.presentationMode.screenShareConnectionInterruptedError') ));
            this._unload();
        });

        //Safari is not able to generate the event: "JitsiMeetJS.events.conference.CONNECTION_INTERRUPTED".
        //So this is a work around to identify when connection is interrupted
        room.on( JitsiMeetJS.events.conference.ENDPOINT_MESSAGE_RECEIVED, (args)=> {
            if( args._connectionStatus == 'interrupted' ) {
                this.showUserErrorMessage(String( this.$i18n.t('meetings.presentationMode.screenShareConnectionInterruptedError') ));
                this._unload();
            }
        });

        room.join();

        if(this._getLocalUsername()) {
            room.setDisplayName(this._getLocalUsername());
        }
    }

    public async _shareScreen() {
        //the modal questions is only required for Safari web browser in order to generate a user gesture handler: 
        //https://stackoverflow.com/questions/62929138/safari-getdisplaymedia-must-be-called-from-a-user-gesture-handler
        //https://webkit.org/blog/13862/the-user-activation-api/
        const promise =  new Promise((resolve, reject) => {
            this.$EdModal.createConfirmationModal({
                body: this.$i18n.t('meetings.presentationMode.screenShareConfirmation'),
                action: () => {
                    const response = JitsiMeetJS.createLocalTracks({devices: [ 'desktop' ]}, true)
                        .then((tracks)=> setTimeout(()=> {
                            this._onLocalTracks(tracks);
                            this._updateLocalIsOnScreenShare(true);
                        }, 50))
                        .catch((errGen) => {
                            log.info('LEGO: Could not create local tracks 1:',errGen);
                            this._updateLocalIsOnScreenShare(false);
                            //-- Browsers incompatibilities or the video is not available
                            // (Ej: we are working just with a second screen).
                            this.showUserErrorMessage(errGen.message || errGen.errorMsg);
                        });
                    resolve(response);
                }, 
                secondAction: () => {
                    resolve(false);
                },
            });
        });

        return promise;
    }

    private showUserErrorMessage(message:string) {
        this.$EdToast.create({ 
            msg: message,
            type: TOAST_TYPES.DANGER,
            top: '3rem',
            timeout: 5000
        });
    }

    async _stopSharingScreen() {
        if(this._getRoom().getLocalTracks().length == 0) {
            this._updateLocalIsOnScreenShare(false)
        }
        await this._unload()
    }

    _disposeLocalTracks() {
        let tracks = this._getRoom().getLocalTracks();
        return Promise.all(
            tracks.map(t =>
                t.dispose()
                    .catch(err => {
                        // Track might be already disposed so ignore such an error.
                        // Of course, re-throw any other error(s).
                        if (err.name !== JitsiMeetJS.TRACK_IS_DISPOSED) {
                            throw err;
                        } else {
                            this._updateLocalIsOnScreenShare(false);
                        }
                    })))
                    .finally(() => {
                        this._updateLocalIsOnScreenShare(false); // This line is added to be sure that Safari turns off the screen share button.
                        this._unload();
                    })
                    .then(() => Promise.all(tracks.map(t => this._trackRemoved(t))));
    }

    _trackRemoved(track) {
        track.removeAllListeners(JitsiMeetJS.TRACK_MUTE_CHANGED);
        track.removeAllListeners(JitsiMeetJS.TRACK_VIDEOTYPE_CHANGED);
        track.removeAllListeners(JitsiMeetJS.NO_DATA_FROM_SOURCE);
    }

    _isLocalId(id) {
        return this._getRoom() ? this._getRoom().myUserId() == id : false;
    }

    _isModerator(role) {
        return role == this.MODERATOR_ROLE;
    }

    _onConnectionFailed(reject) {
        reject(new TohainaError(this.TOHAINA_ERROR_CONN));
    }

    /**
     * This function is called when we disconnect.
     */
     _disconnect() {
        this._getConnection().removeEventListener(JitsiMeetJS.events.connection.CONNECTION_ESTABLISHED, this._onConnectionSuccess);
        this._getConnection().removeEventListener(JitsiMeetJS.events.connection.CONNECTION_FAILED, (err) => this._onConnectionFailed(err));
        this._getConnection().removeEventListener(JitsiMeetJS.events.connection.CONNECTION_DISCONNECTED, this._disconnect);
    }

    /**
     * Handles local tracks.
     */
     _onLocalTracks(tracks) {
        if (tracks.length>0){
            for (let i = 0; i < tracks.length; i++) {
                //tracks[i].addEventListener(JitsiMeetJS.events.track.TRACK_MUTE_CHANGED,() => console.log('LEGO, local track muted'));
                tracks[i].addEventListener(JitsiMeetJS.events.track.LOCAL_TRACK_STOPPED, () => {
                    setTimeout(() => {
                        if(this._getRoom().getLocalTracks().length > 0) {
                            this._stopSharingScreen().then(() => this._updateLocalIsOnScreenShare(false));
                        } else {
                            this._updateLocalIsOnScreenShare(false);
                        }
                    }, 100);
                });
            }
            //this._participantChanged(this.LOCAL);
        }
        //console.log('LEGO, _onConnectionSuccess2, _onLocalTracks ', tracks);
        this._addLocalTracksToRoom(tracks);
    }

    /**
     * Handles remote tracks
     */
     _onRemoteTrack(track) {
         //console.log('LEGO, _onRemoteTrack: ', track);

        if (track.isLocal()) {
            return;
        }
        if(track.getType() == 'audio') {
            return;
        }
        if(track.getType() == 'video') {
            this._updateParticipant({id:track.getParticipantId(), videoTrack: track});
        }
        this._participantChanged(track.getParticipantId());

        //const id = track.getParticipantId() + '-' + track.getType();
        const id = 'screenShareContainer';

        setTimeout(() => {
            this.tryToAttachVideo(track, id);
        }, 2000);
        //console.log('LEGO, onRemoteTrack: ', track);

    }

    tryToAttachVideo(track, id) {
        if(!document.getElementById(id)) {
            setTimeout(() => {
                return this.tryToAttachVideo(track, id);
            }, 1000);
        } else {
            if(track.getType() == 'video' && !track.disposed) {
                try {
                    track.attach($(`#${id}`)[0]);
                    this._updateRemoteIsOnScreenShare(true);
                    //console.log('LEGO, tryToAttachVideo1: ', track.getType(), track, document.getElementById(id));
                } catch(e) {
                    //console.error('LEGO, Error trying to attach video: ', e);
                } finally {
                    this.isConnecting = false;
                }
            }
        }
    }

     _onRemoteJoin(participant, user) {
         /*let userId =  user.getDisplayName().split('|')[0];
         let teacher =  user.getDisplayName().split('|')[1];
         let userName =  user.getDisplayName().split('|')[2];*/
         //this._updateParticipant({id:participant, user:user, userid: userId, username: userName, role: user.getRole(), teacher: teacher})
         this._participantChanged(participant);
    }

    async _onConferenceJoined(resolve) {
        //this._addLocalTracksToRoom();
        //JitsiMeetJS.mediaDevices.addEventListener(JitsiMeetJS.events.mediaDevices.DEVICE_LIST_CHANGED, (devices)=> this._onDeviceListChanged(devices));
        //-- Now, we can show the call controls
        //this.$edEventBus.$emit(CALLS_EVENTS.START_CALL,true);
        //console.log('LEGO, remoteTracks Validation: ', this.isRemoteSharingScreen, this._getRoom().getParticipants());
        let _areTracksInTheMeeting = this._areTracksInTheMeeting();
        const isSomeoneElseSharingScreen = this._getRoom().getParticipants().find( participant => participant._properties['eduac.sharing.screen'] == 'true') != null;

        if(this._getRoom().isJoined() && !this.isRemoteSharingScreen && !_areTracksInTheMeeting && !isSomeoneElseSharingScreen) {
            let isTrackSuccessfullySelected = await this._shareScreen(); 
            
            if( isTrackSuccessfullySelected ) {
                this.setCurrentUserIsSharingItsScreen(true);
            } else {
                this.setCurrentUserIsSharingItsScreen(false);
                await this._unload();
            }
            this.isConnecting = false;
        }

        resolve();
    }

    setCurrentUserIsSharingItsScreen( isSharing:boolean ) {
        this._getRoom()?.setLocalParticipantProperty('eduac.sharing.screen', isSharing);
    }

    _areTracksInTheMeeting() {
        const participantList = this._getRoom().getParticipants();
        //console.log('LEGO, _areTracksInTheMeeting Validation0: ', participantList);
        let areTracks = false;
        if(participantList.length > 0) {
            participantList.forEach(participant => {
                const participantTrackList = participant._tracks || [];
                const participantTrack = participantTrackList.find( track => track.type === 'video');
                if( participantTrack ) {
                    areTracks = true;
                }
            } )
            return areTracks;
        } else {
            //console.log('LEGO, _areTracksInTheMeeting Validation1: ', this._getRoom().getParticipants());
            return areTracks;
        }
    }

    _addLocalTracksToRoom(tracks) {
        for (let i = 0; i < tracks.length; i++) {
            this._getRoom().addTrack(tracks[i]);
            //console.log('LEGO, _onConnectionSuccess3,  _addLocalTracksToRoom', tracks[i]);
        }
    }

    /**
     * User left the meeting
     * @param id
     */
     _onUserLeft(id, user) {
        let tracks = this._tracks(id)
        for (let i = 0; i < tracks.length; i++) {
            let control = document.getElementById(`${id}-${tracks[i].getType()}`);
            if (control) {
                tracks[i].detach(control[0]);
            }
        }
        this._removeParticipant({id: id});
        this._participantChanged(id);
        let isTeacher = false;

        //-- If a teacher leaves the meeting &
        //-- Can run this code because the user that is leaving the meeting was not me (local).
        if (isTeacher && this.$store.state.CallsStore.jitsiCall){
            let ids = this.$store.state.CallsStore.participants
                .filter(p => {
                    return p.id !== id
                }) //-- Remove - double check
                .map(p => p.userid);

            //-- Kick out all participants if there is not a teacher.
            CallsService.activeTeachers({
                meetingId: this.$store.state.CallsStore.conference.meetingId,
                classId: this.$store.state.CallsStore.conference.classId,
                callMemberIds: ids
            }).then((res) => {
                // @ts-ignore
                let callMemberIds = res.callMemberIds;
                if (callMemberIds.length == 0){
                    this.finishAndNotifyCall(this.$store.state.CallsStore.conference.meetingId,
                        this.$store.state.CallsStore.conference.classId, true).then(r =>
                        log.info('LEGO Finish call (there is not a teacher in the meeting)! _onUserLeft')
                    );
                }
            });
        }
    }

    /**
     * Leave the meeting
     */
    async _unload() {
        /**
         * Avoid that userLeft event run for the user that is leaving the meeting.
         */
        //this.$store.commit(_SCREEN_SHARE_STORE.MUTATIONS.ON_JITSI_INIT_CALL, false);

        if(this._getRoom()){
            let tracks = this._getRoom().getLocalTracks();
            if (tracks){
                for (let i = 0; i < tracks.length; i++) {
                    try {
                        tracks[i].dispose();
                    } catch (error) {
                        log.error('Error dispose track.', error);
                    }
                }
            }
            if (this._getRoom() && this._getRoom().isJoined()) {
                await this._getRoom().leave()
                    .then(this._innerDisconnect, this._innerDisconnect)
                    .then(() => {
                        try{
                            this._cleanCallStarted();
                            //document.getElementById('CameraBoard').innerHTML = '';
                            //document.getElementById('call_container_audio').innerHTML = '';
                            const screenShareContainer = document.getElementById('screenShareContainer');
                            if( screenShareContainer ) {
                                screenShareContainer.innerHTML = '';
                            }
                        } catch (error) {
                            log.error('Error trying to leave the room.', error);
                        }
                    }).catch(err => {
                        try{
                            this._cleanCallStarted();
                            //document.getElementById('CameraBoard').innerHTML = '';
                            //document.getElementById('call_container_audio').innerHTML = '';
                            const screenShareContainer = document.getElementById('screenShareContainer');
                            if( screenShareContainer ) {
                                screenShareContainer.innerHTML = '';
                            }
                        } catch (error) {
                            log.error('Error trying to leave the room.', error);
                        }
                    });
            }

        }
    }

    _innerDisconnect() {
        const onDisconnected = () => {
            return Promise.resolve();
        };
        if (!this._getConnection()) {
            return onDisconnected();
        }
        return this._getConnection().disconnect().then(onDisconnected, onDisconnected);
    }

    _getAudioTracks(){
        return this._getTracks(true, 'audioinput')
    }

    _getAudioOutputTracks(){
        return this._getTracks(true, 'audiooutput')
    }

    _getVideoTracks(){
        return this._getTracks(true, 'videoinput')
    }

    _getTracks(excludeDefault:boolean, type:string){
        return new Promise( resolve => {
            let list = [];
            //JitsiMeetJS.mediaDevices.isDeviceChangeAvailable(deviceType) &&
            if (JitsiMeetJS.mediaDevices.isDeviceListAvailable()) {
                JitsiMeetJS.mediaDevices.enumerateDevices(devices => {
                    const devs = devices.filter(d => {
                        return d.kind === type
                    } );
                    if (devs && devs.length > 0) {
                        devs.map(d => {
                            if (excludeDefault){
                                if (this._isNotDefaultItem(d.label)) {
                                    list.push({key: d.deviceId, value: d.label, groupId: d.groupId})
                                }
                            }else{
                                list.push({key: d.deviceId, value: d.label, groupId: d.groupId})
                            }
                        })
                    }
                    resolve(list);
                });
            }else{
                resolve(list);
            }
        });
    }

    /**
     * Remove default item (Fix - Chrome)
     */
    _isNotDefaultItem(deviceName){
        return !(browser.isChromiumBased() && deviceName &&
            (deviceName.startsWith('Default -') || deviceName.startsWith('Predeterminado -')));
    }

    /**
     * Find the current local track & replace with the new one.
     * @param deviceType
     * @param deviceId
     * @param html
     * @param track
     */
    _switchDevice(deviceType, html, newTrack) {
        let oldTrack = this._tracks(this.LOCAL,deviceType)[0];
        if(oldTrack){
            //-- Clean track
            if(deviceType !== 'video'){
                oldTrack.dispose();
            }
            this._replaceTrack(this.LOCAL, deviceType, null);
            oldTrack.detach(html);
            if(oldTrack.isMuted()){
                newTrack.mute();
                /*this.$edEventBus.$emit(_SCREEN_SHARE_STORE.ON_CHANGE_MUTE_DEVICE,
                    { action: 'mute', type: deviceType, deviceId : newTrack.deviceId });*/
            }
            this._replaceTrack(this.LOCAL, deviceType, newTrack);
            newTrack.attach(html[0]);

/*
            this._getRoom().addTrack(newTrack).catch( ()=> {
                this._getRoom().removeTrack(oldTrack).then(()=>{
                    this._getRoom().addTrack(newTrack);
                })
            } );
*/

            if (deviceType == 'video'){
                this._getRoom().removeTrack(oldTrack).then(()=>{
                    this._getRoom().addTrack(newTrack);
                });
            }else{
                // this._getRoom().addTrack(newTrack);
                this._getRoom().removeTrack(oldTrack).then(()=>{
                    this._getRoom().addTrack(newTrack);
                });
            }
        }
        this._participantChanged(this.LOCAL);
    }

    _replaceTrack(participantId:string, deviceType:string, track:any){
        if(deviceType === 'video') {
            this._updateParticipant({id: participantId, videoTrack: track});
        }else if(deviceType === 'audio') {
            this._updateParticipant({id: participantId, audioTrack: track});
        }
    }

     _isDeviceChangeable(){
        return new Promise( resolve => {
            let isVideoChangeable = JitsiMeetJS.mediaDevices.isDeviceListAvailable() &&
                JitsiMeetJS.mediaDevices.isDeviceChangeAvailable('input'); // Camera or Mic.
            let isAudioChangeable = isVideoChangeable && JitsiMeetJS.mediaDevices.isMultipleAudioInputSupported();
            let isAudioOutputChangeable = JitsiMeetJS.mediaDevices.isDeviceListAvailable() &&
                JitsiMeetJS.mediaDevices.isDeviceChangeAvailable('output'); // Mic (Output)

            resolve({ audio: isAudioChangeable, audiooutput: isAudioOutputChangeable, video: isVideoChangeable});
        });
    }

    /**
     * Get id o group id from default device
     * @param deviceType
     */
    _getKeyAndGroup(deviceType){
        return new Promise((resolve)=>{
            let track = this._tracks(this.LOCAL,deviceType)[0];
            if (track){
                let deviceGroup = null;
                let deviceKey = track.deviceId;
                if(track.track.getCapabilities && track.track.getCapabilities().groupId){
                    deviceGroup = track.track.getCapabilities().groupId;
                }
                return resolve( {key:deviceKey, group: deviceGroup} );
            }else{
                let deviceKey = this.LB_UNDEFINED;
                if (deviceType === 'audiooutput'){
                    let devAudioOutput = JitsiMeetJS.mediaDevices.getAudioOutputDevice();
                    if (typeof devAudioOutput !== 'undefined'){
                        this._getTracks(false, deviceType).then(devs =>{
                            // @ts-ignore
                            if (typeof devs !== 'undefined' && devs.length > 0) {
                                let defDev = null;
                                if(devAudioOutput === 'default'){
                                    // @ts-ignore
                                    defDev = devs.find( x => { return x.key === 'default'; } );
                                    resolve({key:deviceKey, group: defDev.groupId});
                                }else{
                                    resolve({key:devAudioOutput, group: null});
                                }

                            }else{
                                resolve({key:deviceKey, group: null});
                            }
                        });
                    }else{
                        resolve({key:deviceKey, group: null});
                    }
                }else{
                    resolve({key:deviceKey, group: null});
                }
            }
        });
    }

    isNotDeviceAvailable(deviceType){
        return !this.isDeviceAvailable(deviceType);
    }

    isDeviceAvailable(deviceType){
        if (deviceType === 'audiooutput') {
            return this.$store.state.CallsStore.audioOutputDevice !== 'undefined' &&
                this.$store.state.CallsStore.audioOutputDevice !== 'default';
        } else if (deviceType === 'audio'){
            return this.$store.state.CallsStore.audioDevice !== 'undefined' &&
                this.$store.state.CallsStore.audioDevice !== 'default';
        } else {
            return this.$store.state.CallsStore.videoDevice !== 'undefined' &&
                this.$store.state.CallsStore.videoDevice !== 'video';
        }
    }

    public async finishCall(endCallData?:any) {
        let meetingIdInStore = this.$store.state.CallsStore.callConfiguration.meetingId;
        if (!endCallData){ //-- from button
            endCallData = await CallsService.getCallById(meetingIdInStore);
        }
        let classIdInStore = this.$store.state.CallsStore.callConfiguration.classId;
        let closeMeetingInBack = endCallData.personId == this.$store.state.AuthStore.user.id;
        let meetId = endCallData ? endCallData.meetingId : meetingIdInStore;
        let classId = endCallData ? endCallData.classId : classIdInStore;
        await this.finishAndNotifyCall(meetId, classId, closeMeetingInBack);
    }

    public async finishAndNotifyCall(meetingId, classId, closeMeetingInBack) {
        this.endCall();
        if (closeMeetingInBack){
            this.$EdSocket.emit(APP_SOCKET_EVENTS.TEACHER_END_CALL_REQUEST, {
                username: this.$store.state.AuthStore.user.fullName,
                messageType: APP_SOCKET_MESSAGES_TYPE.END_CALL,
                content: meetingId,
                topicId: classId
            });
            await CallsService.endCall(meetingId);
        }
    }

    public endCall() {
        try {
            this._unload();
        } catch (err) {
            throw new Error(err);
        }
    }

    _isTeacher(){
        return this.$store.state.AuthStore.role === KEYS.ROLES.PUBLISHER;
    }
}

class TohainaError extends Error {
    public tohainaError : string = '';
    constructor(response, ...params) {
        super(...params)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, TohainaError)
        }
        // Custom Info
        this.tohainaError = response
    }
}
